import 'mdn-polyfills/Node.prototype.append';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom'
import Routes from './routes';
import 'jquery';
import i18next from 'i18next';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import 'moment/locale/fr';
import './common/components/UI/FontAwesome/FontAwesome';
import history from './services/history';


// Application Styles
import './common/styles/BS/bootstrap.min.css';
import './common/styles/index.css';
import './common/styles/custom.css';
import './common/styles/app.scss';
import 'react-daterange-picker/dist/css/react-calendar.css';
import 'tui-calendar/dist/tui-calendar.css';
import 'tui-date-picker/dist/tui-date-picker.css';
import 'tui-time-picker/dist/tui-time-picker.css';
import 'nprogress/nprogress.css';
import 'react-redux-spinner/dist/react-redux-spinner.css';

//Local Variables
var $ = require('jquery');
moment.locale(i18next.language)
// Disable warning "Synchronous XMLHttpRequest on the main thread is deprecated.."
$.ajaxPrefilter(function (options, originalOptions, jqXHR) {
    options.async = true;
});

ReactDOM.render(

    (<Router history={history}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
            <Routes />
        </MuiPickersUtilsProvider>
    </Router>)
    ,
    document.getElementById('root')
);

history.listen(function (ev) {
    $('body').removeClass('aside-toggled');
});
